/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateStructureAnnotation = `mutation UpdateStructureAnnotation(
  $projectId: String!
  $runId: String!
  $massGroup: Int!
  $preClusterId: String!
  $clusterId: String!
  $annotationType: AnnotationType!
  $annotationIndex: Int!
  $metaScore: Float!
  $sugarStructure: AWSJSON!
) {
  updateStructureAnnotation(
    projectId: $projectId
    runId: $runId
    massGroup: $massGroup
    preClusterId: $preClusterId
    clusterId: $clusterId
    annotationType: $annotationType
    annotationIndex: $annotationIndex
    metaScore: $metaScore
    sugarStructure: $sugarStructure
  ) {
    metaScore
    structureId
    annotatedStructure
    annotationType
    annotationIndex
    glycanSpectrumMatches {
      gsmScore
      sugarStructure
    }
  }
}
`;
